<template lang="pug">
.tab.flex_v(
  :class="{ selected: selected && $store.state.navigationStyle == 1, business: selected && $store.state.navigationStyle == 2 }"
)
  img(:src="img")
  h5 {{ title }}
</template>

<script>
export default {
  name: "Tab",
  components: {},
  props: {
    title: String,
    img: String,
    selected: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/scrollable_tab_common";

.tab {
  h5 {
    margin-top: 12px;
    color: $color_black_title;
  }
}

.tab.selected {
  &::after {
    border-bottom: 3px solid $color_blue_tabs_ci;
  }
}

.tab.business {
  &::after {
    border-bottom: 3px solid $color_blue_btn;
  }
}

@media (max-width: 991px) {
  .tab {
    h5 {
      margin-top: 5px;
    }
  }
}

@media (max-width: 767px) {
  .tab {
    h5 {
      margin-top: 1.7vw;
    }
  }
}
</style>
